<script>
import { watch, ref } from 'vue';
import pdfMake from "pdfmake/build/pdfmake";
import { pdfFileName, openPdf } from '@/utils/pdfFile';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import returnServices from '@/services/ReturnServices';

export default {
    props:{
            return_id: Number,
            view_pdf_count: Number,
    },
    setup(props){
        const pdfData=ref([]);
        const documentDefinition=ref({});
        const body=ref([]);
 const loadPdf= ()=>{
     returnServices.getSinglePdf(props.return_id)
        .then(response=>{
          pdfData.value= response.data.data;
        })
                .then(() => {
                    let columns=[];
                    body.value=[];
                    
                    columns=[
                        {text: 'No', style: 'defaultFont', alignment: 'center'},
                        {text: 'Shop', style: 'defaultFont', alignment: 'center'},
                        {text: 'Product', style: 'defaultFont', alignment: 'center'},
                        {text: 'Quantity', style: 'defaultFont', alignment: 'center'},
                        {text: 'Amount', style: 'defaultFont', alignment: 'center'}
                    ];
                    body.value.push(columns);
                    
                    let i=1;
                    pdfData.value.forEach(function(row) {

                        const dataRow=[];
                        const seriol_no={
                            text: i,
                            style: ['defaultFont', 'mtEnglish'],
                            alignment: 'center',
                            
                        };
                        dataRow.push(seriol_no);
                        const shop_name={
                            text: row['shop_name'],
                            style: ['defaultFont', 'mtEnglish'],
                            alignment: 'center'
                        }
                        dataRow.push(shop_name);
                        const product_name={
                            text: row['name'],
                            style: ['defaultFont', 'mtEnglish'],
                            alignment: 'center'
                        }
                        dataRow.push(product_name);

                        const quantity={
                            text: eval(row['quantity']),
                            style: ['defaultFont', 'mtEnglish'],
                            alignment: 'center'
                        }
                        dataRow.push(quantity);

                        const amount={
                            text: row['total_amount'],
                            style: ['defaultFont', 'mtEnglish'],
                            alignment: 'center'
                        }
                        dataRow.push(amount);
                        body.value.push(dataRow);


                        //}
                        i++;
                    });
                   
                })
                .then(() => {
                    pdfMake.fonts = {
					
					Roboto: {
						normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
						bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
						italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
						bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
					},
				}
                    documentDefinition.value = {
                        content: [
                            
                            {
                                columns: [
                                    {
                                    width: '50%',
                                    text: 'Returns LIst',
                                    style: [ 'defaultFont', 'mb10' ]

                                    },
                                    {
                                    width: '50%',
                                    text: 'Print Date: '+moment().format('DD/MM/YY'),
                                    style: [ 'defaultFont', 'textRight', 'mb10' ]
                                    },
                                ],
                                
                            },
                            {
                                
                                table: {
                                    headerRows: 1,
                                     dontBreakRows: true, 
                                    widths: [30, '*','*','*' , '*'],
                                    body: body.value
                                }
                            },
                            
                        ],
                        styles: {
                            defaultFont: {
                            fontSize: 11,
                            bold: true
                            },
                            textRight: {
                            alignment: 'right'
                            },
                            textCenter: {
                            alignment: 'center'
                            },
                            mt2: {
                            margin:[0,2,0,0]
                            },
                            mb2: {
                            margin:[0,0,0,2]
                            },
                            mb10: {
                            margin:[0,0,0,10]
                            },
                            mb15: {
                            margin:[0,3,0,2]
                            },
                            mCustom: {
                            margin:[20,2,0,0]
                            },
                            
                            mtEnglish: {
                                margin:[0,10,0,0]
                            },
                        }
                        };
                })
                .then(() => {
                    
                    pdfMake.vfs = pdfFonts;
                    openPdf(pdfMake, documentDefinition.value, pdfFileName(['Return', props.return_id], ''));
                });

                
        }
        watch( ()=>props.view_pdf_count, (currentValue, oldValue) => {
                loadPdf();
        });
        
        return {
            pdfData,
            documentDefinition,
            body,
            loadPdf,
        }
    }
}
</script>
